exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.tooltip-text[data-v-7afb0d93]{color:#4d4f5c;font-size:12px\n}\n", "", {"version":3,"sources":["/home/vvikas-fedora-hp/dev/hellopeter/portal/src/widgets/TooltipNew.vue"],"names":[],"mappings":";AACA,+BAA+B,cAAc,cAAc;CAC1D","file":"TooltipNew.vue","sourcesContent":["\n.tooltip-text[data-v-7afb0d93]{color:#4d4f5c;font-size:12px\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7afb0d93","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/widgets/TooltipNew.vue
// module id = 8zlw
// module chunks = 4